module.exports = __webpack_public_path__ + "static/media/15.b3170cef.mp3";